// extracted by mini-css-extract-plugin
export var item = "Postitem-module--item--3jGQL";
export var large = "Postitem-module--large--1vagM";
export var item__category = "Postitem-module--item__category--1y0oA";
export var item__title = "Postitem-module--item__title--XttJ9";
export var item__cover = "Postitem-module--item__cover--2YgNc";